import React from 'react';
import styled from 'styled-components';
import {MenuAccountInfo, MobileMenuButtonTypes, DesktopMenuButtonTypes} from '../types';
import {IconButton} from '../../Button';
import {ProfileButton} from '../../ProfileButton';
import {SystemIcons} from '../../icons';
import {BREAKPOINTS} from '../../styles';

const Wrapper = styled.div`
  align-items: center;

  display: none;

  ${BREAKPOINTS.MEDIUM} {
    display: flex;
  }
`;

const ProfileWrapper = styled.div`
  margin: 0 8px;
`;


interface DesktopActionsProps {
  buttons?: DesktopMenuButtonTypes[];
  user?: MenuAccountInfo;
  profileComponent?: React.ReactNode
  onShowUserMenu: () => void;
}

export interface DesktopActionsRef {
  buttons?: { ref: React.MutableRefObject<HTMLButtonElement | null>, type: 'profile' | 'action' | 'switcher' | undefined }[]
}

const  DesktopActions = React.forwardRef(({
                                           buttons,
                                           user,
                                            profileComponent,
                                           onShowUserMenu
                                         }: DesktopActionsProps, ref: React.Ref<DesktopActionsRef>) => {

  const [elRefs, setElRefs] = React.useState<React.RefObject<HTMLButtonElement>[]>([]);

  const length = buttons?.length || 0;

  React.useEffect(() => {
    setElRefs(Array(length || 0).fill(null).map(() => React.createRef<HTMLButtonElement>()));
  }, [length]);

  React.useImperativeHandle(ref, () => ({
    buttons: elRefs.map((r, index) => ({
      ref: r,
      type: buttons?.[index]?.type,
    }))
  }), [elRefs, buttons]);

  const renderItem = (item: MobileMenuButtonTypes, index: number) => {
    switch (item.type) {
      case 'profile': {
        const {placement, type, action, ...rest} = item;
        if(!!profileComponent)
          return <ProfileWrapper>{profileComponent}</ProfileWrapper>;
        else
          return <ProfileWrapper>
            <ProfileButton key={index}
                           ref={elRefs[index]}
                           hideOnLowWidth={true}
                           onClick={e => {
                             item.action ? item.action(e?.target) : onShowUserMenu()
                           }}
                           icon={!user && <SystemIcons.User/>}
                           initials={(user?.firstName?.charAt(0) ?? '') + (user?.lastName?.charAt(0) ?? '')}
                           {...rest}/>
          </ProfileWrapper>
      }
      case 'action': {
        const {placement, type, icon, action, ...rest} = item;
        return <IconButton key={index}
                           ref={elRefs[index]}
                           variant={'secondary'}
                           shape={'circular'}
                           hideOnLowWidth={true}
                           action={e => item.action && item.action(e?.target)}
                           {...rest}>
          {item.icon}
        </IconButton>
      }
      case 'switcher': {
        const {placement, type, action, ...rest} = item;
        return <IconButton key={index}
                           ref={elRefs[index]}
                           variant={'secondary'}
                           shape={'circular'}
                           hideOnLowWidth={true}
                           id="globalNavAppsButton"
                           action={e => item.action && item.action(e?.target)}
                           {...rest}>
          <SystemIcons.SwitchApp size="24px"/>
        </IconButton>
      }
    }
  }

  return (
    <Wrapper role="toolbar" aria-label="Toolbar">
      {buttons?.map((item, index) => renderItem(item, index))}
    </Wrapper>
  )
});


export default DesktopActions;
